import {
  HStack,
  IconButton,
  Text,
  Th,
  Tooltip,
  TableColumnHeaderProps,
} from '@chakra-ui/react';

import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';

export type SortDirection = 'asc' | 'desc';

export interface SortState {
  sortField: string;
  sortDirection: SortDirection;
  onSort: (field: string) => void;
}

interface SortableThProps extends TableColumnHeaderProps, SortState {
  label: string;
  field: string;
}

const SortableTh = ({
  label,
  field,
  sortField,
  sortDirection,
  onSort,
  ...thProps
}: SortableThProps) => {
  const isActive = sortField === field;

  return (
    <Th pe="10px" color="gray.400" {...thProps}>
      <HStack spacing={1}>
        <Text color="gray.400">{label}</Text>
        <Tooltip label={`Sort by ${label}`} hasArrow>
          <IconButton
            aria-label={`Sort by ${label}`}
            icon={
              isActive && sortDirection === 'desc' ? (
                <ChevronDownIcon />
              ) : (
                <ChevronUpIcon />
              )
            }
            size="xs"
            variant="ghost"
            color={isActive ? 'brand.500' : 'gray.400'}
            onClick={() => onSort(field)}
          />
        </Tooltip>
      </HStack>
    </Th>
  );
};

export default SortableTh;
